import _defineProperty from "/vercel/path0/apps/corona/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

var _summarizeQuestions;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import * as R from 'ramda';
import { SoapType } from 'src/types';
import { SOAP_TYPES } from '../soap';
import NUTRITIONAL_CONSULTATION_V1 from './NUTRITIONAL_CONSULTATION/v1.0.json';
import NUTRITIONAL_SUPPLEMENT_V1 from './NUTRITIONAL_SUPPLEMENT/v1.0.json';
import NUTRITIONAL_SUPPLEMENT_V2 from './NUTRITIONAL_SUPPLEMENT/v2.0.json';
export var summarizeQuestions = (_summarizeQuestions = {}, _defineProperty(_summarizeQuestions, SoapType.NUTRITIONAL_SUPPLEMENT, [NUTRITIONAL_SUPPLEMENT_V2, NUTRITIONAL_SUPPLEMENT_V1]), _defineProperty(_summarizeQuestions, SoapType.NUTRITIONAL_CONSULTATION, [NUTRITIONAL_CONSULTATION_V1]), _summarizeQuestions);
export var getSummarizeQuestions = R.pipe(R.pathOr([], ['pages']), R.chain(R.path(['elements'])), R.defaultTo([]));
export var getQuestionMap = function getQuestionMap() {
  var questions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return questions.reduce(function (acc, cur, idx) {
    return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, cur.name, _objectSpread(_objectSpread({}, cur), {}, {
      order: idx
    })));
  }, {});
};
export var getSummarizeQuestionsFromMemoCategory = function getSummarizeQuestionsFromMemoCategory(category, version) {
  return R.pipe(R.values, R.find(function (soap) {
    return (soap === null || soap === void 0 ? void 0 : soap.memoCategory) === category;
  }), R.pathOr([], ['summarizeQuestions']), R.find(function (group) {
    return group.version === version;
  }), getSummarizeQuestions)(SOAP_TYPES);
};
export var getSoapTypeFromMemoCategory = function getSoapTypeFromMemoCategory(category) {
  return R.pipe(R.values, R.find(function (soap) {
    return (soap === null || soap === void 0 ? void 0 : soap.memoCategory) === category;
  }), R.propOr(undefined, 'key'))(SOAP_TYPES);
};